<template>
  <div class="mx-4 px-4">
    <div class="vx-row">
        <div class="vx-col w-full">
          <SidebarTitle icon="Edit3Icon" title="title" class="mt-8" />
            <vs-input
                label=""
                v-model="dream.title"
                name="title"
                class="w-full"
                autocomplete="off"
                ref="titleInput"
            />
            <label v-if="errors.has('title')" class="text-danger block text-sm mt-2 mb-5">
                {{ errors.first('title') }} <br />
            </label>


            <SidebarTitle icon="Edit2Icon" title="description" class="mt-8"/>
            <vs-input
              label=""
              color="dark"
              v-model="dream.subtitle"
              :rows="$store.getters.isMobile ? 3 : 5"
              class="w-full mb-5"
              @keyup.enter.native="save"
            />

            <RelatedAreas :key="`RelatedAreasDream-${editedEntity.id}`" class="mt-8 mb-8" v-model="dream.relatedAreas" />

            <!-- Image -->
            <SidebarTitle icon="ImageIcon" title="image" class="mt-8"/>
            <div v-if="!$store.getters.isMobile" class="mb-5">
                <div v-if="dream.img && !imageFile" class="w-full">
                    <transition name="zoom-fade">
                      <div class="flex items-center justify-center mt-4">
                        <img
                          :src="dream.img"
                          style="max-height: 120px"
                        >
                        <span class="flex items-center" @click="removeImage" :class="actionElementCss">
                          <feather-icon icon="Trash2Icon" svgClasses="ml-4 w-4 h-4" />
                          <span  class="">remove</span>
                        </span>

                      </div>


                    </transition>
                </div>
                <div v-if="!dream.img" class="flex">
                    <transition name="zoom-fade">
                        <vs-upload
                            id="image"
                            :limit="1"
                            class="mx-auto w-full"
                            text="Change Dream Image"
                            :show-upload-button="false"
                            accept="image/*;capture=camera"
                            @change="imgFileChanged"
                        />
                    </transition>
                </div>
            </div>
            <div v-else class="vx-row mb-5">
                <div :key="dream.img ? dream.img : 'no-dream'" class="vx-col w-full">
                    <transition name="zoom-fade">
                      <div v-if="dream.img" class="flex justify-center items-center mt-4">
                          <img
                              :src="dream.img"
                              style="max-height: 15vh"
                              @click="$refs.fileInput.click()"
                          >
                          <span class="flex items-center" @click="removeImage" :class="actionElementCss">
                            <feather-icon icon="Trash2Icon" svgClasses="ml-4 w-4 h-4" />
                            <span  class="">remove</span>
                          </span>
                      </div>
                    </transition>
                    <div v-show="!dream.img">
                        <input type="file" ref="fileInput" class="hidden" accept="image/*;capture=camera" @change="mobileFileInputHandler">
                        <div
                            @click="$refs.fileInput.click()"
                            class="px-8 py-4 cursor-pointer text-center border border-solid d-theme-border-grey-light d-theme-dark-bg"
                        >
                            <feather-icon icon="UploadCloudIcon" svgClasses="h-8 w-8 stroke-current text-grey" class="block" />
                            <span>Drop Image or </span>
                            <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">Browse</span>
                        </div>
                    </div>
                </div>
            </div>


            <DiveDeeper>
              <DiveDeeperItem title="why is this dream important to me?" v-model="dream.whyDescription"/>

              <DiveDeeperItem title="what would I gain by achieving this dream?" v-model="dream.gainDescription"/>

              <DiveDeeperItem title="what are possible risks and obstacles?" v-model="dream.riskDescription"/>
            </DiveDeeper>


  <!--               <label for="progress" class="vs-input--label">Progress</label>
            <div class="px-2 mb-2">
                <vs-slider
                    v-model="dream.progress"
                    label="Progress"
                    name="progress"
                    class="w-full"
                    :color="progressColor(dream.progress)"
                    :step="5"
                />
            </div> -->
        </div>
    </div>

    <vs-divider  v-if="false" class=""/>
    <InfoCard v-if="false" title="long-term & fascinating">
      <p class="mb-3">Dream ‑ a picture of the future that produces passion. What could be, what will be.</p>
      <p class="mb-3 font-bold">The distance between your dreams and reality is on the action board.</p>

      <p class="italic">„Your vision is not limited by what your eye can see, but by what your mind can imagine.“ — Ellison Onizuka</p>
    </InfoCard>
  </div>
</template>
<script>
import _ from 'lodash'
import progressColor from '@/helpers/progressColor'
import trackAnalytics from '@/helpers/trackAnalytics'
import CategorySelect from './CategorySelect'
import DiveDeeper from '@/views/Self-Improvee/Planner/DiveDeeper'
import DiveDeeperItem from '@/views/Self-Improvee/Planner/DiveDeeperItem'

export default {
  components: {
    CategorySelect,
    DiveDeeper,
    DiveDeeperItem
  },
  props: {
    editedEntity: {
      type: Object,
      required: false,
      default: () => {}
    },
    firstDream: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      dream: {},
      imageFile: null,
    }
  },
  watch: {
    editedEntity: {
      immediate: true,
      async handler (editedEntity) {
        this.dream = _.merge({}, this.dreamDefaults, editedEntity)
        if (editedEntity) {
          await this.$validator.resume()
        } else {
          await this.$validator.pause()
        }
      }
    },
  },
  computed: {
    dreamDefaults () {
      return {
        subtitle: '',
        whyDescription: '',
        gainDescription: '',
        riskDescription: '',
        img: '',
        relatedAreas: []
      }
    },
    validateForm () {
      return !this.errors.any()
    },
    edit () {
      return !!_.get(this.editedEntity, 'id')
    },
    isNewAction () {
      return !this.edit
    },
  },
  beforeDestroy () {
    this.$root.$off('dreamSidebarFooterSaveClicked')
  },
  mounted () {
    this.$root.$on('dreamSidebarFooterSaveClicked', () => {
      this.save()
    })
  },
  methods: {
    removeImage () {
      this.dream.img = null
    },
    progressColor (progress) {
      return progressColor(progress, true)
    },
    close () {
      this.imageFile = null
      this.$emit('close')
    },
    save () {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return
        if (this.imageFile) await this.uploadImage()
        this.$store.dispatch(this.edit ? 'UPDATE_DREAM' : 'ADD_DREAM', { dream: this.dream })
        trackAnalytics(this, 'app_action', this.edit ? 'update_dream' : 'add_dream', null, this.$store.getters.daysFromRegistration)
        this.pushFlashMessage()
        this.close()
      })
    },
    pushFlashMessage () {
      if (!this.isNewAction) return

      // if (this.firstDream) {
      //   this.$vs.notify({
      //     title:'You have created your first dream',
      //     text:'Now You can plan your goals',
      //     color:'success',
      //     iconPack: 'feather',
      //     time: 4000,
      //     icon:'icon-check'})
      // } else {
      //   this.$vs.notify({
      //     title:'Awesome',
      //     text:'Dream created',
      //     color:'success',
      //     iconPack: 'feather',
      //     icon:'icon-check'})
      // }
    },
    destroy () {
      if (!confirm('Are you sure?')) return

      // this.$store.dispatch('DELETE_GOALS_BY_DREAM', { dream_id: this.dream.id })

      this.$store.dispatch('DELETE_DREAM', { dream: this.dream })

      // this.$store.getters.goalsByDream(this.dream).forEach((goal) => {
      // this.$store.dispatch('DELETE_GOAL', { goal })
      // })

      trackAnalytics(this, 'app_action', 'delete_dream', null, this.$store.getters.daysFromRegistration)
      this.close()
    },
    imgFileChanged (path, files) {
      const file = files[0]
      this.imageFile = file
    },
    mobileFileInputHandler (e) {
      // TODO: refactor
      const files = e.target.files
      const file = files[0]
      if (!file) return
      this.imageFile = file
      this.dream.img = URL.createObjectURL(file)
    },
    async uploadImage () {
      this.dream.img = await this.$store.dispatch('UPLOAD_DREAM_IMAGE', {
        file: this.imageFile,
        dream: this.dream
      })
    }
  }
}
</script>
<style>
.img-upload, .con-upload, .con-img-upload, .con-input-upload {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}

.con-input-upload {
  height: 120px;
}

.view-upload {
  display: none !important;
}
</style>
